<script>
import baseMixin from '@/mixins/baseMixin'

export default {
  name: 'NamePlaceholder',
  mixins: [baseMixin],
  props: {
    text: { type: String, default: '' },
    classificationName: { type: String, default: '' },
  },
}
</script>

<template>
  <div class="d-flex align-center no-educator-wrapper">
    <v-icon size="20" class="rounded-full no-educator">mdi-account</v-icon>

    <div v-if="isMobile" class="d-flex flex-column text-start">
      <span class="no-educator-text ml-2">{{ text }}</span>
      <span class="ml-2"> {{ classificationName }}</span>
    </div>

    <span v-else class="no-educator-text pl-2">{{ text }}</span>
  </div>
</template>

<style lang="scss" scoped>
@import '@/styles/_colors.scss';
.no-educator-wrapper {
  .no-educator {
    width: 32px;
    height: 32px;
    background-color: $color-neutral-grey-200;
    border-radius: 100%;

    .v-icon {
      color: $color-gray-550;
    }
  }

  .no-educator-text {
    padding-top: 1px;
    font-weight: 400;
    line-height: normal;
    color: $color-gray-600;
  }
}
</style>
